import { Button, IconButton, Tooltip } from '@ads/components-react';
import { ArrowDownTray } from '@ads/icons';
import type { ReportType } from '@linka/domain/enums';
import { useTranslation } from '@linka/i18n';
import { cn } from '@linka/utils';
import { useSetAtom } from 'jotai';
import { exportChartAtom } from './state';

interface ExportChartTriggerButtonProps {
  type: ReportType;
  className?: string;
}

export const ExportChartTriggerButton = ({ type, className }: ExportChartTriggerButtonProps) => {
  const t = useTranslation();
  const setExportChart = useSetAtom(exportChartAtom);

  if (['CHECKIN', 'PRODUCT_WITHDRAWAL', 'ORDERS_CHECKOUT', 'SALES'].includes(type)) {
    return (
      <Button
        onClick={() => setExportChart(type)}
        className={cn('!w-full sm:!w-auto', className)}
        leadingIcon={ArrowDownTray}
        size='lg'
      >
        {t('export-flow.export-data')}
      </Button>
    );
  }

  return (
    <Tooltip title={t('export-flow.export-data')}>
      <IconButton
        className={cn(className)}
        size='sm'
        icon={ArrowDownTray}
        hierarchy='secondary'
        ariaLabel={t('export-flow.export')}
        onClick={() => setExportChart(type)}
      />
    </Tooltip>
  );
};
